import styled from 'styled-components'

export const HeaderSection = styled.div<{ isDarkMode?: any }>`
	height: 60px;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding-inline: 16px;
	font-size: 3vw;
	z-index: 90001;
	position: fixed;
	top: 0;
	left: 0;
	background-color: ${props => props.theme.COLORS.background};
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
`
export const MHeaderSearchSection = styled.div`
	flex: 1;
	display: flex;
	flex-direction: row;
`
export const HeaderInput = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	height: 34px;
	padding-inline: 10px;
	background: ${p => p.theme.COLORS.gray};
	border-radius: 15px;
`
